export const isUpgradeOfferedInFlow = (
  isUpgradeInBasket: boolean,
  isPackageRate: boolean,
  isExtrasOffered = false
) => !isUpgradeInBasket || isPackageRate || isExtrasOffered;
